import { LOGIN_MODE } from "@libs/interfaces/layouts"
import { default_login } from "@libs/layouts"
import { Widgets } from "@libs/utilities"
import { IState, useMainStore } from "src/settings/zustand"
import LayoutLoginedUser from './LayoutLoginedUser'
import LayoutUnloginned from './LayoutUnloginned'
import LayoutUnLoginnedExternal from "./LayoutUnLoginnedExternal"

const LayoutUser = (props: ILayoutUserProps) => {
    return (
		<>
            <Widgets areaName="before-profile" data={{ ...props }} />
            <LayoutUserPanel {...props}/>
        </>
    )
}
 

export default LayoutUser

export interface ILayoutUserProps {
    isOpen: boolean
}

const LayoutUserPanel = (props: ILayoutUserProps) => { 
    const user = useMainStore(( state: IState ) => state.user)
    return user?.id 
        ? 
        <LayoutLoginedUser {...props}/> 
        : 
        default_login() === LOGIN_MODE.LOGIN
            ?
            <LayoutUnloginned {...props}/>
            :
            <LayoutUnLoginnedExternal {...props} />
}